"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPForm = exports.BpCheckedIcon = exports.BpIcon = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var react_hook_form_1 = require("react-hook-form");
var styles_2 = require("@mui/material/styles");
var PPDropDown_1 = __importDefault(require("../PPDropDown/PPDropDown"));
var PPIconLink_1 = require("../PPIconLink");
var styles_3 = require("./styles");
var theme_1 = require("./theme");
var PPMultiSelect_1 = __importDefault(require("../PPMultiSelect/PPMultiSelect"));
exports.BpIcon = (0, styles_2.styled)('span')(function (_a) {
    var theme = _a.theme;
    return ({
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow: theme.palette.mode === 'dark'
            ? '0 0 0 1px rgb(16 22 26 / 40%)'
            : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
        backgroundImage: theme.palette.mode === 'dark'
            ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
            : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
        },
    });
});
exports.BpCheckedIcon = (0, styles_2.styled)(exports.BpIcon)({
    backgroundColor: '#FFB800',
    borderColor: '#FFFFFF',
    borderWidth: '2px',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""',
    },
    'input:hover ~ &': {
        backgroundColor: '#FFB800',
    },
});
var PPForm = function (props) {
    var classes = (0, styles_3.useStyles)();
    var handleChangeMultiple = function (event) {
        var options = event.target.options;
        var value = [];
        if (options instanceof Array)
            for (var i = 0, l = options.length; i < l; i += 1) {
                if (options[i].selected) {
                    value.push(options[i].value);
                }
            }
        else
            event && event.target && value.push(event.target.value);
        if (value && value.length == 1) {
            return value[0];
        }
        return value;
    };
    var loading = false;
    if (props && props.loading) {
        loading = props.loading;
    }
    var _a = (0, react_1.useState)(0), errorCount = _a[0], setErrorCount = _a[1];
    var _b = (0, react_1.useState)(0), counter = _b[0], setCounter = _b[1];
    var _c = (0, react_1.useState)(props.template), template = _c[0], setTemplate = _c[1];
    var _d = (0, react_hook_form_1.useForm)({
        mode: "all", reValidateMode: 'onChange', criteriaMode: "firstError",
        shouldFocusError: true, defaultValues: props.data, shouldUnregister: true
    }), register = _d.register, handleSubmit = _d.handleSubmit, control = _d.control, errors = _d.formState.errors, getValues = _d.getValues, setValue = _d.setValue, trigger = _d.trigger;
    var Salvar = function (func) {
        if (func.skipvalidation != null && func.skipvalidation == true) {
            executeOperationOnRecord(props, getValues, trigger, func);
            return;
        }
        setErrorCount(0);
        trigger();
        template.fields.map(function (fieldItem) {
            trigger(fieldItem.name);
        });
        template.fields.map(function (fieldItem) {
            trigger(fieldItem.name).then(function () {
                props.setError && props.setError(errors);
                if (props.enableNotifications
                    && errors !== undefined
                    && fieldItem !== undefined
                    && fieldItem.name !== undefined
                    && errors[fieldItem.name] !== undefined
                    && errors[fieldItem.name].message !== undefined) {
                    var count = errorCount + 1;
                    setErrorCount(count);
                }
            });
        });
        handleSubmit(onSubmit, onError)();
        props.setError && props.setError(errors);
        props.setResultData && props.setResultData(getValues());
    };
    (0, react_1.useEffect)(function () {
        var interfaceTyped = __assign({}, props.data);
        try {
            setTemplate(props.template);
            Object.keys(props.data).map(function (field) {
                interfaceTyped = props.data;
                setValue(field, interfaceTyped[field]);
                trigger(field);
            });
        }
        catch (e) { }
    }, [props.EditForm]);
    (0, react_1.useEffect)(function () {
        Salvar({});
    }, [props.refreshSeed]);
    if (props == undefined || props == null) {
        return (react_1.default.createElement("div", null));
    }
    function executeOperationOnRecord(props, getValues, trigger, func) {
        var interfaceTyped = __assign({}, props.data);
        var interfaceTypedNewValues = __assign({}, getValues());
        Object.keys(getValues()).map(function (field) {
            trigger(field);
            interfaceTyped[field] = interfaceTypedNewValues[field];
        });
        if (func)
            func.func(interfaceTyped);
    }
    var onSubmit = function () {
        var _a;
        if (errorCount == 0) {
            var funca = props && props.functions && ((_a = props.functions) === null || _a === void 0 ? void 0 : _a.filter(function (x) { return x.skipvalidation == false; })[0]);
            props && props.functions && funca && executeOperationOnRecord(props, getValues, trigger, funca);
        }
    };
    var onError = function () { };
    return (react_1.default.createElement(react_1.default.Fragment, null, !loading && react_1.default.createElement("div", null,
        react_1.default.createElement("div", { style: { margin: 0, padding: 0 } },
            react_1.default.createElement("div", { className: "header", style: { margin: 0, padding: 0 } },
                react_1.default.createElement(core_1.Typography, { variant: "h5", color: "textPrimary", component: "p" }, props.header)),
            props.detailButton &&
                react_1.default.createElement("div", { className: "sequence", style: { marginBottom: 6, padding: 0 } }, props.functions &&
                    props.functions.filter(function (x) { return x.disabled != true; }).map(function (func, index) {
                        return (react_1.default.createElement(PPIconLink_1.PPIconLink, { id: func.id, tooltip: func.tooltip, key: index, icon: func.icon, onClick: function () { Salvar(func); } }));
                    })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("form", null,
                    react_1.default.createElement(core_1.Grid, { container: true, spacing: 0 }, template.fields.filter(function (x) {
                        return ((x.edit == true && (props.EditForm == true || props.EditForm == undefined)) || (props.EditForm == false));
                    })
                        .sort(function (a, b) {
                        if (a.row > b.row)
                            return 1;
                        else if (b.row > a.row)
                            return -1;
                        return 0;
                    })
                        .map(function (field, index) {
                        var type = field.type, title = field.title, name = field.name, required = field.required, disabled = field.disabled, colspan = field.colspan, formatData = field.formatData, denpendentFieldFilter = field.denpendentFieldFilter, multiselect = field.multiselect;
                        var colspanField = 2;
                        if (colspan != undefined) {
                            colspanField = (colspan * 6);
                        }
                        var formatedData = (props.data[name] != null) ? props.data[name] : '';
                        if (formatData) {
                            formatedData = formatData(formatedData);
                        }
                        {
                            !required && (required = {});
                        }
                        switch (type) {
                            case 'textarea':
                            case 'textArea':
                                return (react_1.default.createElement(core_1.Grid, { key: "Grid".concat(index), container: true, sm: colspanField, xs: 12, style: { position: 'relative', paddingLeft: 0, paddingRight: 0, paddingTop: 0, fontSize: 12 } },
                                    react_1.default.createElement(styles_1.ThemeProvider, { theme: theme_1.theme },
                                        react_1.default.createElement(core_1.Box, { className: "colorFont", style: { minWidth: '80%' } },
                                            react_1.default.createElement(core_1.Grid, { container: true },
                                                react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                                                    title && (react_1.default.createElement(core_1.Grid, { container: true, className: classes.label },
                                                        react_1.default.createElement(core_1.Grid, { item: true, xs: true, sm: true, md: true, lg: true, xl: true }, title))),
                                                    react_1.default.createElement(core_1.TextField, __assign({ key: name, multiline: true, rows: "5", style: { marginRight: '15px', minWidth: '100%' }, error: errors[name] != null ? true : false, required: required.value == true, InputLabelProps: {
                                                            shrink: true,
                                                        }, fullWidth: true, className: classes[required.value ? 'multiline_required' : 'multiline'], title: title, variant: "outlined", defaultValue: formatedData, disabled: disabled, label: false }, register(name, { validate: function (value) { return required.value ? (value && value != undefined) ? true : required.required : true; } }), { size: "small" }))))))));
                                break;
                            case 'file':
                                return (react_1.default.createElement(core_1.Grid, { key: "Grid".concat(index), item: true, sm: colspanField, xs: 12 },
                                    react_1.default.createElement(core_1.FormGroup, { key: "FormGroup".concat(index), style: { position: 'relative', paddingLeft: 0, paddingRight: 0, paddingTop: 0, fontSize: 12 } },
                                        react_1.default.createElement(core_1.InputLabel, { key: "InputLabel".concat(index), error: errors[name] != null ? true : false, style: { position: 'relative', paddingLeft: 0, paddingRight: 0, paddingTop: 0, fontSize: 12, margin: 0 }, htmlFor: "outlined-age-simple" }, title),
                                        react_1.default.createElement(core_1.TextField, { key: name, style: {
                                                position: 'relative', paddingLeft: 0, marginLeft: 10, marginRight: 10,
                                                paddingRight: 0, paddingTop: 0,
                                                left: '-5px', backgroundColor: '#FFFFFF', fontSize: 12
                                            }, type: 'file', error: errors[name] != null ? true : false, required: required.value == true, InputLabelProps: {
                                                shrink: true,
                                            }, variant: "standard", size: "small", defaultValue: formatedData, name: name, disabled: disabled, helperText: errors[name] != null ? required.message : "" }))));
                                break;
                            case 'password':
                                {
                                    !required && (required = {});
                                }
                                return (react_1.default.createElement(core_1.Grid, { key: "Grid".concat(index), item: true, sm: colspanField, xs: 12 },
                                    react_1.default.createElement(core_1.FormGroup, { key: "FormGroup".concat(index), style: { position: 'relative', paddingLeft: 0, paddingRight: 0, paddingTop: 0, fontSize: 12 } },
                                        react_1.default.createElement(core_1.InputLabel, { key: "InputLabel".concat(index), error: errors[name] != null ? true : false, style: {
                                                position: 'relative', paddingLeft: 0, marginLeft: 10, marginRight: 10,
                                                paddingRight: 0, paddingTop: 0,
                                                fontSize: 12, margin: 0
                                            }, htmlFor: "outlined-age-simple" }, title),
                                        react_1.default.createElement(core_1.TextField, { key: name, style: {
                                                position: 'relative', width: '90%',
                                                left: '-5px', backgroundColor: '#FFFFFF',
                                                paddingLeft: 0, paddingRight: 0,
                                                paddingTop: 0, fontSize: 12
                                            }, type: 'password', error: errors[name] != null ? true : false, required: required.value == true, InputLabelProps: {
                                                shrink: true,
                                            }, size: "small", defaultValue: formatedData, variant: "standard", name: name }))));
                                break;
                            case 'checkbox':
                                return (react_1.default.createElement(core_1.Grid, { key: "Grid".concat(index), item: true, sm: colspanField, xs: 12 },
                                    react_1.default.createElement(styles_1.ThemeProvider, { theme: theme_1.theme },
                                        " ",
                                        react_1.default.createElement(core_1.FormControl, { key: "FormControl".concat(index), error: errors[name] != null ? true : false, component: "fieldset", style: { margin: 8 } },
                                            react_1.default.createElement(core_1.FormControlLabel, { key: "FormControlLabel".concat(index), control: react_1.default.createElement(core_1.Checkbox, __assign({ disabled: disabled, required: required.value == true, defaultChecked: formatedData }, register(name, { validate: function (value) { return required.value ? (value != undefined) ? true : required.required : true; } }), { style: {
                                                        color: '#FFB800',
                                                        width: '20px',
                                                        height: '28px',
                                                        left: '0px',
                                                        top: '0px',
                                                        flex: 'none',
                                                        margin: '0px 8px',
                                                        borderColor: 'white'
                                                    }, checkedIcon: react_1.default.createElement(exports.BpCheckedIcon, null), icon: react_1.default.createElement(exports.BpIcon, null) })), label: title })))));
                                break;
                            case 'number':
                                return (react_1.default.createElement(core_1.Grid, { key: "Grid".concat(index), container: true, sm: colspanField, xs: 12, style: { position: 'relative', paddingLeft: 0, paddingRight: 0, paddingTop: 0, fontSize: 12 } },
                                    react_1.default.createElement(styles_1.ThemeProvider, { theme: theme_1.theme },
                                        react_1.default.createElement(core_1.Box, { className: "colorFont", style: { minWidth: '80%' } },
                                            react_1.default.createElement(core_1.Grid, { container: true },
                                                react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                                                    title && (react_1.default.createElement(core_1.Grid, { container: true, className: classes.label },
                                                        react_1.default.createElement(core_1.Grid, { item: true, xs: true, sm: true, md: true, lg: true, xl: true }, title))),
                                                    react_1.default.createElement(core_1.TextField, __assign({ key: name, type: 'number', multiline: true, style: { marginRight: '15px', minWidth: '100%' }, error: errors[name] != null ? true : false, required: required.value == true, InputLabelProps: {
                                                            shrink: true,
                                                        }, fullWidth: true, className: classes[required.value ? '_required' : 'root'], title: title, variant: "outlined", defaultValue: formatedData, disabled: disabled, label: false }, register(name, { validate: function (value) { return required.value ? (value && value != undefined) ? true : required.required : true; } }), { size: "small" }))))))));
                                break;
                            case 'text':
                                return (react_1.default.createElement(core_1.Grid, { key: "Grid".concat(index), container: true, sm: colspanField, xs: 12, style: { position: 'relative', paddingLeft: 0, paddingRight: 0, paddingTop: 0, fontSize: 12 } },
                                    react_1.default.createElement(styles_1.ThemeProvider, { theme: theme_1.theme },
                                        react_1.default.createElement(core_1.Box, { className: "colorFont", style: { minWidth: '80%' } },
                                            react_1.default.createElement(core_1.Grid, { container: true },
                                                react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                                                    title && (react_1.default.createElement(core_1.Grid, { container: true, className: classes.label },
                                                        react_1.default.createElement(core_1.Grid, { item: true, xs: true, sm: true, md: true, lg: true, xl: true }, title))),
                                                    react_1.default.createElement(core_1.TextField, __assign({ key: name, multiline: true, style: { marginRight: '15px', minWidth: '100%' }, error: errors[name] != null ? true : false, required: required.value == true, InputLabelProps: {
                                                            shrink: true,
                                                        }, fullWidth: true, className: classes[required.value ? '_required' : 'root'], title: title, variant: "outlined", defaultValue: formatedData, disabled: disabled, label: false }, register(name, { validate: function (value) { return required.value ? (value && value != undefined) ? true : required.required : true; } }), { size: "small" }))))))));
                                break;
                            case 'money':
                                return (react_1.default.createElement(core_1.Grid, { key: "Grid".concat(index), container: true, sm: colspanField, xs: 12, style: { position: 'relative', paddingLeft: 0, paddingRight: 0, paddingTop: 0, fontSize: 12 } },
                                    react_1.default.createElement(styles_1.ThemeProvider, { theme: theme_1.theme },
                                        react_1.default.createElement(core_1.Box, { className: "colorFont", style: { minWidth: '80%' } },
                                            react_1.default.createElement(core_1.Grid, { container: true },
                                                react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                                                    title && (react_1.default.createElement(core_1.Grid, { container: true, className: classes.label },
                                                        react_1.default.createElement(core_1.Grid, { item: true, xs: true, sm: true, md: true, lg: true, xl: true }, title))),
                                                    react_1.default.createElement(core_1.TextField, __assign({ key: name, multiline: true, style: { marginRight: '15px', minWidth: '100%' }, error: errors[name] != null ? true : false, required: required.value == true, InputLabelProps: {
                                                            shrink: true,
                                                        }, fullWidth: true, className: classes[required.value ? '_required' : 'root'], title: title, variant: "outlined", defaultValue: formatedData, disabled: disabled, label: false }, register(name, { validate: function (value) { return required.value ? (value && value.lenght > 0) ? true : required.required : true; } }), { size: "small" }))))))));
                                break;
                            case 'select':
                                {
                                    var options_1 = field.options;
                                    try {
                                        if (denpendentFieldFilter) {
                                            options_1 = denpendentFieldFilter.filter(getValues());
                                        }
                                        if (options_1 && options_1.length == 1) {
                                            setValue(name, options_1[0].value);
                                            trigger(name);
                                        }
                                    }
                                    catch (e) {
                                    }
                                    return ((options_1 && options_1.length > 0) &&
                                        react_1.default.createElement(core_1.Grid, { key: "Grid".concat(index), item: true, sm: colspanField, xs: 12 },
                                            react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: name, rules: {
                                                    validate: function () {
                                                        return ((required.value ? (getValues(name) != "-1" && getValues(name) != undefined) ? true : required.required : true));
                                                    }
                                                }, render: function () { return (react_1.default.createElement(core_1.Box, { className: "colorFont", style: { maxWidth: '80%' } }, multiselect ?
                                                    react_1.default.createElement(PPMultiSelect_1.default, { name: name, 
                                                        //label={title}
                                                        error: { show: errors[name] != null, help: "" }, key: name, onChange: function (val) {
                                                            var values = handleChangeMultiple(val);
                                                            setValue(name, values);
                                                            trigger(name);
                                                            var count = counter;
                                                            count = count + 1;
                                                            setCounter(count);
                                                        }, disabled: disabled, options: options_1, required: required.value == true })
                                                    :
                                                        react_1.default.createElement(PPDropDown_1.default, { name: name, 
                                                            //label={title}
                                                            error: { show: errors[name] != null, help: "" }, key: name, onChange: function (val) {
                                                                var values = handleChangeMultiple(val);
                                                                setValue(name, values);
                                                                trigger(name);
                                                                var count = counter;
                                                                count = count + 1;
                                                                setCounter(count);
                                                            }, disabled: disabled, options: options_1, required: required.value == true }))); } })));
                                }
                                break;
                            default:
                                return (react_1.default.createElement("div", { key: "di".concat(index) },
                                    react_1.default.createElement("span", null, "Invalid Field")));
                        }
                    }))),
                props.children && react_1.default.createElement("div", { key: 'Extra' }, props.children)),
            props.detailButton && react_1.default.createElement(core_1.Grid, { className: "topbar", style: { margin: 0, padding: 0 } },
                react_1.default.createElement(core_1.Grid, { className: "functions", style: { marginBottom: 6, padding: 0 } }, props.functions &&
                    props.functions.filter(function (x) { return x.disabled != true; }).map(function (func, index) {
                        return (react_1.default.createElement("button", { id: func.id, key: index, onClick: function () { Salvar(func); }, className: "lc-button bg-primary mr-5" }, func.title));
                    })))))));
};
exports.PPForm = PPForm;
